/* eslint-disable no-param-reassign */
import axios from 'axios';
import store from '../store/index';
import i18n from '../i18n/i18n-config';

axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;
axios.interceptors.request.use((config) => config);
axios.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 500: {
          store.commit('ui/openSnackbar', i18n.t('http_errors.500'));
          throw error;
        }
        default: {
          /**
           *  List of error messages that have error messages written for them.
           *  To add another response code:
           *    1) add translations messages to src/i18n/{locale}/error-messages
           *    2) include the error code in showErrorMessagesFor array
           *  To add custom handling for a given error, see the above examples for 401 and 500
           */
          const showErrorMessagesFor = [400, 403, 404, 422, 429];
          if (showErrorMessagesFor.indexOf(error.response.status) > -1) {
            store.commit('ui/openSnackbar', i18n.t(`http_errors.${error.response.status}`));
          }
          throw error;
        }
      }
    } else if (typeof error === 'string') {
      store.commit('ui/openSnackbar', error);
      throw error;
    } else {
      store.commit('ui/openSnackbar', {
        text: i18n.t('network_error'),
        timeout: 10000,
      });
      throw error;
    }
  },
);

export default axios;
